import type { SVGProps } from 'react';

interface GenerateDeliveryOrderIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function GenerateDeliveryOrderIcon({ className, ...props }: GenerateDeliveryOrderIconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect
        x="0.75"
        y="0.75"
        width="12.5"
        height="12.5"
        rx="1.25"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M9.75003 0.75V5.54297C9.75003 5.73853 9.53572 5.85829 9.36917 5.75586L7.918 4.8623C7.3553 4.51577 6.64477 4.51577 6.08206 4.8623L4.63089 5.75586C4.46435 5.85829 4.25003 5.73854 4.25003 5.54297V0.75H9.75003Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
